export const kitchenThrottleConfig = {
  kitchenThrottleConfig: {
    countDefault: 5,
    valueDefault: 3,
    displayInfo: {
      EN: "We're sorry - our kitchen is at capacity and we cannot accept more Orders at the moment! Please try again in 15 minutes.",
    },
    timeslots: {
      THURSDAY: [
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
      ],
      MONDAY: [
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: 5000,
          throttlingEnabled: true,
        },
        {
          count: 9,
          value: 5000,
          throttlingEnabled: true,
        },
        {
          count: 9,
          value: 5000,
          throttlingEnabled: true,
        },
        {
          count: 20,
          value: 5000,
          throttlingEnabled: true,
        },
        {
          count: 20,
          value: 8000,
          throttlingEnabled: true,
        },
        {
          count: null,
          value: 8000,
          throttlingEnabled: true,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: 1000,
          throttlingEnabled: true,
        },
        {
          count: 30,
          value: null,
          throttlingEnabled: true,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
      ],
      TUESDAY: [
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
      ],
      SUNDAY: [
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
      ],
      WEDNESDAY: [
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: 2000,
          throttlingEnabled: true,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
      ],
      SATURDAY: [
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
      ],
      FRIDAY: [
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
        {
          count: null,
          value: null,
          throttlingEnabled: false,
        },
      ],
    },
  },
};
